<template>
  <div class="content">
    <div class="content-header">
      <h3>{{ title.key }}</h3>
    </div>
    <paginate
      ref="photoPaginate"
      name="photosPaginated"
      :list="filterPhotos"
      :per="12"
      :refreshCurrentPage="true"
      class="photo-gallery-listed"
    >
      <div
        class="photo"
        v-for="(img, i) in paginated('photosPaginated')"
        :key="i"
        @click="index = i"
      >
        <progressive-background class="background-image" :src="thumb(img.ImageLink)">
          <div slot="content" slot-scope="{ visible }">
            <i v-if="visible" class="diginity dg-loading diginity-is-spinning"></i>
          </div>
        </progressive-background>
        <!-- <img :src="thumb(img.ImageLink)" alt=""> -->
      </div>
    </paginate>
    <paginate-links
      for="photosPaginated"
      :limit="3"
      :show-step-links="true"
      :hide-single-page="true"
    ></paginate-links>
    <vue-gallery :images="arrayImage" :index="index" @close="index = null"></vue-gallery>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      index: -1,
      paginate: ["photosPaginated"],
    };
  },
  computed: {
    ...mapGetters(["file", "t", "photos_list", "thumb"]),
    title() {
      const pageTitle = this.t.photosMenu.find((item) => {
        return item.position == this.$route.params.year;
      });
      return pageTitle;
    },
    filterPhotos() {
      return this.photos_list.filter((photo) => {
        return this.title.id == photo.Parent.ID;
      });
    },
    arrayImage() {
      const arraySource = [];
      this.paginated("photosPaginated").find((img) => {
        arraySource.push(this.file(img.ImageLink));
      });
      return arraySource;
    },
  },
  watch: {
    "$route.params.year"(newValue, oldValue) {
      if (
        this.$refs.photoPaginate.lastPage > 0 ||
        this.$refs.photoPaginate.currentPage > 0
      ) {
        this.$refs.photoPaginate.goToPage(1);
      }
    },
  },
  components: { VueGallery },
};
</script>

<style lang="scss" scoped>
.photo-gallery-listed {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 30px;
  @media screen and (max-width: 760px) {
    justify-content: center;
  }
  .photo {
    padding: 10px;
    display: flex;
    height: 160px;
    width: 160px;
    align-items: center;
    .background-image {
      cursor: pointer;
      width: 100%;
      height: 100%;
      border: 8px solid #fff;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
      background-size: cover;
      background-position: center;
      position: relative;
      &:after {
        display: flex;
        content: "\ea19";
        font: normal normal normal 1em/1 "Diginity";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        color: #fff;
        justify-content: center;
        align-items: center;
        text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.7);
        transition: all 0.25s cubic-bezier(0.32, -0.08, 0.65, 1.84);
        z-index: 10;
        font-size: 20px;
        opacity: 0;
        background: rgba(255, 255, 255, 0.2);
      }
      &:hover {
        &:after {
          opacity: 1;
          font-size: 40px;
        }
      }
    }
  }
}
.progressive-image-preloader {
  align-items: center !important;
  justify-content: center !important;
}
</style>
